import { isPerUnitProductVariant, isTiersProductVariant, isUsageProduct } from '@weft/services';
import type { Product, ProductVariant, UsageProduct, UsageProductVariant } from '@weft/types';
import { isNullOrUndefined, raise } from '@weft/utils';
import { getRateMultiplierAdjustedPerUnitPricing } from './rate-multiplier-product-processor-helpers/per-unit-pricing-rate-multiplier-processor';
import { getRateMultiplierAdjustedTiersPricing } from './rate-multiplier-product-processor-helpers/tiers-pricing-rate-multiplier-processor';

export function processRateMultiplierPlanProducts(products: Product[]): Product[] {
  return products.reduce<Product[]>((newProducts, currentProduct) => {
    return !isUsageProduct(currentProduct) || isNullOrUndefined(currentProduct.rateMultiplier) 
      ? [...newProducts, currentProduct]
      : [...newProducts, getRateMultiplierAdjustedProduct(currentProduct, currentProduct.rateMultiplier)];
  }, []);
}

function getRateMultiplierAdjustedProduct(product: UsageProduct, rateMultiplier: number): Product {
  const newProductVariants = product.variants.reduce<ProductVariant[]>((newVariants, currentVariant) => {
    return [...newVariants, getPricingAdjustedProductVariant(currentVariant, rateMultiplier)];
  }, []);

  return {
    ...product,
    variants: newProductVariants,
  };
}

function getPricingAdjustedProductVariant(productVariant: UsageProductVariant, rateMultiplier: number): UsageProductVariant {
  if (isTiersProductVariant(productVariant)) {
    return {
      ...productVariant,
      pricing: getRateMultiplierAdjustedTiersPricing(productVariant.pricing, rateMultiplier),
    };
  }

  if (isPerUnitProductVariant(productVariant)) {
    return {
      ...productVariant,
      pricing: getRateMultiplierAdjustedPerUnitPricing(productVariant.pricing, rateMultiplier),
    };
  }

  return raise(`Unsupported product variant type: ${productVariant}`);
}